import React from "react";
import { FilterBar } from "@sscs/ui";
import { EndpointFilter, SecretLivenessFilter, ServiceFilter, } from "../../../common";
import { useReportSelector } from "../../../hooks";
import { isFilteredByLink } from "../../../utils";
import { selectFilteredByLink } from "../../store/secretsSlice";
import { initFilter } from "../utils";
import TriagedSwitch from "./../../../common/secrets/TriagedSwitch/TriagedSwitch";
import styles from "./filter.module.scss";
const Filter = ({ filter, services, endpoints, onFilterChange, }) => {
    const filteredByLink = useReportSelector(selectFilteredByLink);
    return (React.createElement(FilterBar, { filters: [
            {
                id: "service",
                row: 1,
                minWidth: "225px",
                control: (React.createElement(ServiceFilter, { value: filter.service, services: services, className: styles["autocomplete-filter"], onChange: (value) => onFilterChange({
                        secret_liveness: filter.secret_liveness,
                        service: value,
                        endpoint: filter.endpoint,
                        hide_triaged: filter.hide_triaged,
                    }), "data-filtered-by-link": isFilteredByLink(filter, initFilter, "service", filteredByLink) })),
            },
            {
                id: "endpoint",
                row: 2,
                minWidth: "225px",
                control: (React.createElement(EndpointFilter, { value: filter.endpoint, endpoints: endpoints, className: styles["autocomplete-filter"], onChange: (value) => onFilterChange({
                        secret_liveness: filter.secret_liveness,
                        service: filter.service,
                        endpoint: value,
                        hide_triaged: filter.hide_triaged,
                    }) })),
            },
            {
                id: "liveness",
                row: 2,
                width: "200px",
                control: (React.createElement(SecretLivenessFilter, { value: filter.secret_liveness, onChange: (value) => onFilterChange({
                        secret_liveness: value,
                        service: filter.service,
                        endpoint: filter.endpoint,
                        hide_triaged: filter.hide_triaged,
                    }), className: styles.liveness, "data-filtered-by-link": isFilteredByLink(filter, initFilter, "secret_liveness", filteredByLink) })),
            },
            {
                id: "triaged",
                row: 2,
                fit: true,
                control: (React.createElement(TriagedSwitch, { hideTriaged: filter.hide_triaged, onToggle: (checked) => onFilterChange({ ...filter, hide_triaged: checked }) })),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map